import { TExportType } from "ui/export/types";

const ONE_KB = 1024;
const DEFAULT_DECIMAL_PLACE = 2;
const MAX_FILE_SIZE = 10;
export const MAX_FILE_UPLOAD_SIZE = MAX_FILE_SIZE * ONE_KB * ONE_KB;

export const getFileSize = (
  sizeInBytes: number,
  decimalPlace: number = DEFAULT_DECIMAL_PLACE
): string => {
  if (sizeInBytes < ONE_KB) {
    return `${sizeInBytes} bytes`;
  } else if (sizeInBytes < ONE_KB * ONE_KB) {
    return `${(sizeInBytes / ONE_KB).toFixed(decimalPlace)} KB`;
  }
  return `${(sizeInBytes / (ONE_KB * ONE_KB)).toFixed(decimalPlace)} MB`;
};

export const handleDownloadBufferData = (payload: {
  name: string;
  data: number[];
  type: TExportType | "xlsx";
}) => {
  const { name, data, type } = payload;
  let mimeType = "";
  if (type === "pdf") {
    mimeType = "application/pdf";
  } else if (type === "xlsx") {
    mimeType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  } else if (type === "csv") {
    mimeType = "text/csv";
  } else {
    console.error("Error: Invalid mimetype!");
    return;
  }
  const uint8Array = new Uint8Array(data);
  const blob = new Blob([uint8Array], { type: mimeType });
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  // Cleanup
  document.body.removeChild(a);
  URL.revokeObjectURL(blobUrl);
};
